import React from 'react';

const CountBox = ({ balls, strikes, outs }) => (
  <div className="flex gap-4 items-center">
    <div className="flex flex-col items-center gap-1">
      <span className="text-[7px] uppercase tracking-widest text-[#658d71] font-bold">Balls</span>
      <div className="flex gap-1">
        {[0, 1, 2, 3].map(i => (
          <div key={i} className={`w-3 h-3 rounded-full border-2 ${i < balls ? 'bg-[#a9c9b1] border-[#a9c9b1]' : 'border-[#658d71]'}`} />
        ))}
      </div>
    </div>
    <div className="flex flex-col items-center gap-1">
      <span className="text-[7px] uppercase tracking-widest text-[#658d71] font-bold">Strikes</span>
      <div className="flex gap-1">
        {[0, 1, 2].map(i => (
          <div key={i} className={`w-3 h-3 rounded-full border-2 ${i < strikes ? 'bg-[#c4333e] border-[#c4333e]' : 'border-[#658d71]'}`} />
        ))}
      </div>
    </div>
    <div className="flex flex-col items-center gap-1">
      <span className="text-[7px] uppercase tracking-widest text-[#658d71] font-bold">Outs</span>
      <div className="flex gap-1">
        {[0, 1, 2].map(i => (
          <div key={i} className={`w-3 h-3 rounded-full border-2 ${i < outs ? 'bg-[#d8ceb3] border-[#d8ceb3]' : 'border-[#658d71]'}`} />
        ))}
      </div>
    </div>
  </div>
);

const BasesDiamond = ({ runners }) => {
  const onFirst = runners?.some(r => r.movement?.end === '1B' || r.movement?.start === '1B');
  const onSecond = runners?.some(r => r.movement?.end === '2B' || r.movement?.start === '2B');
  const onThird = runners?.some(r => r.movement?.end === '3B' || r.movement?.start === '3B');

  return (
    <div className="relative w-14 h-14 shrink-0">
      <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-4 h-4 rotate-45 border-2 ${onSecond ? 'bg-[#d8ceb3] border-[#d8ceb3]' : 'border-[#658d71]'}`} style={{ top: '20%' }} />
      <div className={`absolute w-4 h-4 rotate-45 border-2 ${onThird ? 'bg-[#d8ceb3] border-[#d8ceb3]' : 'border-[#658d71]'}`} style={{ top: '50%', left: '10%', transform: 'translateY(-50%) rotate(45deg)' }} />
      <div className={`absolute w-4 h-4 rotate-45 border-2 ${onFirst ? 'bg-[#d8ceb3] border-[#d8ceb3]' : 'border-[#658d71]'}`} style={{ top: '50%', right: '10%', transform: 'translateY(-50%) rotate(45deg)' }} />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-4 h-4 rotate-45 border-2 border-[#386646] bg-[#386646]" />
    </div>
  );
};

const CurrentAtBat = ({ currentPlay, linescore }) => {
  if (!currentPlay) return null;

  const batter = currentPlay.matchup?.batter?.fullName || '--';
  const pitcher = currentPlay.matchup?.pitcher?.fullName || '--';
  const count = currentPlay.count || {};
  const outs = linescore?.outs ?? count.outs ?? 0;
  const runners = currentPlay.runners || [];
  const lastPitch = [...(currentPlay.playEvents || [])].reverse().find(e => e.isPitch);
  const inning = currentPlay.about?.inning;
  const isTop = currentPlay.about?.isTopInning;

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.1)] p-3 flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-[#c4333e] animate-pulse" />
        <span className="text-[9px] font-black uppercase tracking-widest text-[#c4333e]">
          Current At-Bat · {isTop ? '▲' : '▼'}{inning}
        </span>
      </div>

      <div className="flex items-start gap-4 flex-wrap">
        <div className="flex flex-col gap-1 flex-1 min-w-0">
          <div className="flex flex-col gap-0.5">
            <span className="text-[7px] text-[#658d71] uppercase tracking-widest font-bold">Batter</span>
            <span className="text-sm font-black uppercase tracking-wide text-white truncate">{batter}</span>
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="text-[7px] text-[#658d71] uppercase tracking-widest font-bold">Pitcher</span>
            <span className="text-xs font-bold uppercase tracking-wide text-[#a9c9b1] truncate">{pitcher}</span>
          </div>
          {lastPitch && (
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              <span className="text-[8px] text-[#658d71] font-bold uppercase tracking-widest">Last Pitch:</span>
              <span className="text-[9px] font-black text-[#d8ceb3]">{lastPitch.details?.type?.description || '--'}</span>
              {lastPitch.pitchData?.startSpeed && (
                <span className="text-[9px] font-black text-[#a9c9b1] tabular-nums">
                  {Math.round(lastPitch.pitchData.startSpeed)} mph
                </span>
              )}
            </div>
          )}
        </div>

        <div className="flex flex-col items-center gap-3">
          <BasesDiamond runners={runners} />
          <CountBox balls={count.balls ?? 0} strikes={count.strikes ?? 0} outs={outs} />
        </div>
      </div>
    </div>
  );
};

export default CurrentAtBat;